import React from 'react';

import PropTypes from 'prop-types';

import { Skeleton } from '@/components/ui/skeleton';

const RecordCount = ({ from, to, isLoading, recordType, totalRecords }) => {
  if (isLoading) return <Skeleton className="h-6 w-48" />;

  return (
    <span>
      Displaying {from} - {to} of {totalRecords} {recordType}
    </span>
  );
};

RecordCount.propTypes = {
  from: PropTypes.number.isRequired,
  isLoading: PropTypes.bool.isRequired,
  recordType: PropTypes.string.isRequired,
  to: PropTypes.number.isRequired,
  totalRecords: PropTypes.number.isRequired,
};

export default RecordCount;
